import { c as _c } from "react/compiler-runtime";
import { useEffect, useMemo, useState } from 'react';
import { useQuery } from '@apollo/client';
import formatDuration from 'commons/formatDuration';
import getVideoType from 'commons/getVideoType';
import { GET_VIDEO_METADATA } from 'mocks/queries';
const useVideoMetadata = t0 => {
  const $ = _c(26);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    skip: t2,
    videoId
  } = t1;
  const skip = t2 === undefined ? false : t2;
  const [durationInSeconds, setDurationInSeconds] = useState(0);
  const [thumbnail, setThumbnail] = useState("");
  let t3;
  if ($[2] !== videoId) {
    t3 = getVideoType(videoId);
    $[2] = videoId;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const videoType = t3;
  const isFile = videoType === "file";
  let t4;
  if ($[4] !== videoId || $[5] !== videoType) {
    t4 = {
      id: videoId,
      type: videoType
    };
    $[4] = videoId;
    $[5] = videoType;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = skip || isFile || !videoId;
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = {
      variables: t4,
      skip: t5
    };
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const {
    loading,
    data: t7
  } = useQuery(GET_VIDEO_METADATA, t6);
  let t8;
  if ($[10] !== t7) {
    t8 = t7 === undefined ? {} : t7;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const data = t8;
  const {
    getVideoMetadata
  } = data;
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => {
      setDurationInSeconds(0);
      setThumbnail("");
    };
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== videoId) {
    t10 = [videoId];
    $[13] = videoId;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  useEffect(t9, t10);
  let t11;
  let t12;
  if ($[15] !== getVideoMetadata || $[16] !== loading || $[17] !== skip) {
    t11 = () => {
      if (skip || loading || !getVideoMetadata) {
        return;
      }
      if (getVideoMetadata.duration) {
        setDurationInSeconds(getVideoMetadata.duration);
      }
      if (getVideoMetadata.thumbnails.length > 0) {
        const url = getVideoMetadata.thumbnails.length > 3 ? getVideoMetadata.thumbnails[3] : getVideoMetadata.thumbnails[0];
        setThumbnail(url);
      }
    };
    t12 = [getVideoMetadata, loading, skip];
    $[15] = getVideoMetadata;
    $[16] = loading;
    $[17] = skip;
    $[18] = t11;
    $[19] = t12;
  } else {
    t11 = $[18];
    t12 = $[19];
  }
  useEffect(t11, t12);
  let t13;
  if ($[20] !== durationInSeconds) {
    t13 = formatDuration(durationInSeconds);
    $[20] = durationInSeconds;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  const duration = t13;
  const t14 = isFile && !skip ? videoId : "";
  let t15;
  if ($[22] !== duration || $[23] !== t14 || $[24] !== thumbnail) {
    t15 = {
      duration,
      thumbnail,
      videoUrl: t14
    };
    $[22] = duration;
    $[23] = t14;
    $[24] = thumbnail;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  return t15;
};
export default useVideoMetadata;